import type { RestartRejectedMessage } from '@bn-games/network-protocol';

/**
 * The client's view of the shared restart handshake: one proposal per seat
 * per game, and at most one open at a time. The server enforces both; this
 * only mirrors them so the pause menu can say why Restart is unavailable.
 */
export class RestartHandshake {
  private pending = false;
  private used = false;

  state(): { pending: boolean; canPropose: boolean } {
    return { pending: this.pending, canPropose: !this.used };
  }

  /** Spend our proposal; false when there is none to spend or one is already open. */
  propose(): boolean {
    if (this.pending || this.used) return false;
    this.used = true;
    return true;
  }

  opened(): void {
    this.pending = true;
  }

  cancelled(): void {
    this.pending = false;
  }

  /**
   * `already_proposed` confirms our proposal is spent. `another_pending` hands
   * it back, and tells us of an open proposal whose `RESTART_PENDING` we missed.
   */
  rejected(reason: RestartRejectedMessage['reason']): void {
    this.used = reason === 'already_proposed';
    if (reason === 'another_pending') this.pending = true;
  }

  /** A new game: nothing open, a fresh proposal each. */
  reset(): void {
    this.pending = false;
    this.used = false;
  }
}
